import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheckCircle, FaGlobe, FaUsers, FaLightbulb } from "react-icons/fa";
import "./WhyVDNI.css";

const WhyVDNI = () => {
  return (
    <section className="why-vdni-section">
      <Container>
        <Row className="align-items-center">
          {/* Left side: Image */}
          <Col lg={6} md={12} className="why-image">
            <img src="/Images/why-fttune.png" alt="Why VDNI" />
          </Col>

          {/* Right side: Content */}
          <Col lg={6} md={12} className="why-content">
            <h1 className="why-title">Why Choose VDNI?</h1>
            <p className="why-intro">
              VDNI empowers businesses worldwide with cutting-edge digital solutions. We combine creativity, technology, and expertise to ensure your brand thrives online.
            </p>

            <div className="why-features">
              <div className="feature">
                <FaCheckCircle className="feature-icon" />
                <div>
                  <h4>One Stop Solution</h4>
                  <p>From SEO, SEM, PPC, website & app development to branding, we cover all aspects to grow your business efficiently.</p>
                </div>
              </div>

              <div className="feature">
                <FaUsers className="feature-icon" />
                <div>
                  <h4>Expert Teams</h4>
                  <p>Our teams include Graphics Designers, Content Writers, Digital Marketers, and Client Support specialists.</p>
                </div>
              </div>

              <div className="feature">
                <FaGlobe className="feature-icon" />
                <div>
                  <h4>Global Distribution</h4>
                  <p>We deliver end-to-end solutions worldwide, connecting clients directly to decision-makers for instant results.</p>
                </div>
              </div>

              <div className="feature">
                <FaLightbulb className="feature-icon" />
                <div>
                  <h4>Innovative Culture</h4>
                  <p>Our energetic and innovative environment fosters leadership, creativity, and client-focused results.</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyVDNI;
